import Image from "next/image";
import { IFertilityJourneyStep } from "./types";
import { cn } from "@workspace/ui/lib/utils";

export function StepCard({ steps }: { steps: IFertilityJourneyStep[] }) {
  return (
    <div className="flex flex-col px-5 py-5 pb-4 gap-5 bg-[#F3F4ED] rounded-[12px]">
      {steps.map((step, index) => (
        <div
          key={index}
          className={cn(
            "flex flex-col pb-5 border-b border-[#E9EAE1]",
            index === steps.length - 1 && "border-b-0"
          )}
        >
          <div className="flex justify-between gap-[14px]">
            <div className="flex flex-col gap-1">
              <h3 className="text-primary title-14"
              id={`question-option-${index}`}
              data-testid={`question-option-${index}`}
              >
                {step.title}
              </h3>
              <p className="text-muted-foreground title-14"
              id={`question-option-description-${index}`}
              data-testid={`question-option-description-${index}`}
              >
                {step.description}
              </p>
            </div>
            <Image
              src={step.image}
              alt={step.title}
              width={56}
              height={56}
              className="object-contain"
            />
          </div>
        </div>
      ))}
    </div>
  );
}
